module.exports = "<div #baFullCalendar class=\"ba-full-calendar {{baFullCalendarClass || ''}}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baFullCalendar/baFullCalendar.html
// module id = 787
// module chunks = 14